import type { ReactNode } from 'react';
import { SECTION_LABEL_FONT_SIZE } from '@/components/base/SectionHeading';

/** 左カラムのセクション名（INFO / ACCESS 等）— 縦並び */
export function InfoSidebarSectionTitle({ children }: { children: ReactNode }) {
  return (
    <div className="mb-10">
      <span
        className="block font-medium tracking-widest text-slate-800"
        style={{ fontSize: SECTION_LABEL_FONT_SIZE, fontFamily: '"Inter", sans-serif' }}
      >
        {children}
      </span>
      <div className="mt-3 h-0.5 w-8 rounded-sm bg-[#B48C50]" style={{ opacity: 0.45 }} aria-hidden />
    </div>
  );
}

type InfoFieldProps = {
  label: string;
  children: ReactNode;
};

/**
 * ラベル（小・トラッキング多め）と本文（大・濃色）のジャンプ率を高くする用。
 * ラベル下に短いアクセントライン（ブランド色）。
 */
export function InfoField({ label, children }: InfoFieldProps) {
  return (
    <div>
      <div className="mb-3.5">
        <p
          className="mb-2.5 text-[16px] font-semibold uppercase leading-none tracking-[0.12em] text-slate-500"
          style={{ fontFamily: '"Inter", sans-serif' }}
        >
          {label}
        </p>
        <div className="h-0.5 w-8 rounded-sm bg-[#B48C50]" style={{ maxWidth: '2rem' }} aria-hidden />
      </div>
      <div className="text-[18px] font-normal leading-[1.8] text-slate-900 [&_a]:text-slate-900 [&_a]:transition-colors">
        {children}
      </div>
    </div>
  );
}
